import { tv } from 'tailwind-variants';

const outputStyles = tv({
  base: 'w-fit mx-auto mb-2',
  variants: {
    design: {
      primary: 'text-secondary-two',
      admin: 'text-secondary-one',
    },
    size: {
      sm: 'text-sm',
      md: 'text-base',
      lg: 'text-lg',
    },
    errored: {
      true: 'text-primary-two',
    },
  },
  defaultVariants: {
    design: 'primary',
    size: 'md',
  },
});

const inputStyles = tv({
  base: 'bg-zinc-200 rounded-lg flex flex-1 min-w-fit w-full max-w-full text-sm text-gray-800 data-[placeholder]:text-sm focus-visible:outline-none transition-all',
  variants: {
    design: {
      primary: 'accent-primaryFixxer-one',
      admin: 'accent-secondary-two',
    },
    inputSize: {
      sm: '',
      md: '',
      lg: '',
    },
    disabled: {
      true: 'disabled:cursor-not-allowed disabled:opacity-50',
    },
    errored: {
      true: 'border-primary-two',
    },
  },
  defaultVariants: {
    design: 'primary',
    inputSize: 'md',
  },
});

export const rangeStyles = {
  output: outputStyles,
  input: inputStyles,
};
